import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "@/views/Home.vue";
import MapPage from "@/views/Map.vue";
import StagePage from "@/views/Stage.vue";
import StatusPage from "@/views/Status.vue";
import SecretPage from "@/views/Secret.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage
  },
  {
    path: "/map",
    name: "Map",
    component: MapPage
  },
  {
    path: "/stage/:id",
    name: "stage",
    component: StagePage
  },
  {
    path: "/status",
    name: "Status",
    component: StatusPage
  },
  {
    path: "/3_2_1___magro",
    name: "Secret",
    component: SecretPage
  }
];

const router = new VueRouter({
  routes
});

export default router;
